import Layout from "../../containers/Layout";
import { Grid, Skeleton, Box } from "@chakra-ui/react";
import { useParams, useSearchParams } from "react-router-dom";
import CardDetail from "../commons/CardDetail/CardDetail";
import InfiniteScroll from "react-infinite-scroll-component";
import { Spinner } from "@chakra-ui/react";
import axios from "axios";
import { useEffect, useState, useCallback } from "react";
import Seo from "../Seo/Seo";

const Materials = () => {
  const { type } = useParams();
  const typeLabel = type ? type.charAt(0).toUpperCase() + type.slice(1) : "";
  const [searchParams] = useSearchParams();
  const selectedLevel = searchParams.get("nivel");
  const [materiales, setMateriales] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);

  const getLevelValues = (level) => {
    const normalized = (level || "").toLowerCase();

    switch (normalized) {
      case "basico":
      case "a1":
      case "a2":
        return ["A1", "A2"];
      case "intermedio":
      case "b1":
      case "b2":
        return ["B1", "B2"];
      case "avanzado":
      case "c1":
      case "c2":
        return ["C1", "C2"];
      default:
        return null;
    }
  };

  const levelValues = getLevelValues(selectedLevel);

  const fetchMateriales = useCallback(
    async (pageToFetch) => {
      try {
        const params = new URLSearchParams({ page: String(pageToFetch) });
        if (selectedLevel) {
          params.set("nivel", selectedLevel);
        }

        const res = await axios.get(
          `/api/materials/${type || "undefined"}?${params.toString()}`,
        );
        setMateriales((prev) => [...prev, ...res.data.result]);
        setHasMore(res.data.hasMore);
        setPage(pageToFetch + 1);
      } catch (err) {
        console.error("Error fetching materials:", err);
      }
    },
    [selectedLevel, type],
  );

  useEffect(() => {
    setMateriales([]);
    setHasMore(true);
    setPage(1);
    window.scrollTo({ top: 0, behavior: "smooth" });
    fetchMateriales(1);
  }, [selectedLevel, type, fetchMateriales]);

  const isLoading = materiales.length === 0;
  const visibleMateriales = levelValues
    ? materiales.filter((material) =>
        levelValues.includes(material.nivel?.toUpperCase()),
      )
    : materiales;

  return (
    <Layout pt={16}>
      <Seo
        title={type ? `${typeLabel} — Free Spanish Learning Materials` : "Free Spanish Learning Materials"}
        description={
          type
            ? `Browse free ${typeLabel.toLowerCase()} Spanish learning materials — practice with real content from Alex.`
            : "Browse free Spanish learning materials — grammar guides, videos, and podcasts to practice with Alex."
        }
        path={type ? `/materiales/${type}` : "/materiales"}
      />
      <InfiniteScroll
        key={type}
        dataLength={materiales.length}
        next={() => fetchMateriales(page)}
        hasMore={hasMore}
        loader={
          <div style={{ textAlign: "center", padding: "20px" }}>
            <Spinner size="xl" color="blue.500" />
          </div>
        }
      >
        {isLoading ? (
          <Grid templateColumns={{ base: "1fr", md: "repeat(3, 1fr)" }} gap={6}>
            {Array(9)
              .fill(0)
              .map((_, i) => (
                <Box key={i} p={4}>
                  <Skeleton height="200px" />
                </Box>
              ))}
          </Grid>
        ) : (
          <Grid templateColumns={{ base: "1fr", md: "repeat(3, 1fr)" }} gap={6}>
            {visibleMateriales.map((m) => (
              <CardDetail material={m} key={m._id} />
            ))}
          </Grid>
        )}
      </InfiniteScroll>
    </Layout>
  );
};

export default Materials;
